import type { ICustomAuthInlineForm } from './types';
import { AuthInlineFormProvider as AuthInlineFormComponent } from './ui/AuthInlineFormProvider';
import { AfterSlot, BeforeSlot } from './ui/Slots';

const CustomAuthInlineForm = AuthInlineFormComponent as ICustomAuthInlineForm;

CustomAuthInlineForm.Before = BeforeSlot;
CustomAuthInlineForm.After = AfterSlot;

export { CustomAuthInlineForm };
